import { ChangeRequests as ChangeRequestsComponent } from '../../../components/ChangeRequest';

export function ChangeRequests() {
  return <ChangeRequestsComponent />;
}
